import { IExpensesReport } from '../Client/IExpensesReport'

export const GET_EXPENSES_REPORT_REQUEST = 'GET_EXPENSES_REPORT_REQUEST'
export const GET_EXPENSES_REPORT_SUCCESS = 'GET_EXPENSES_REPORT_SUCCESS'
export const GET_EXPENSES_REPORT_FAILURE = 'GET_EXPENSES_REPORT_FAILURE'

interface GeExpensesReportAction {
    type: typeof GET_EXPENSES_REPORT_REQUEST
}

interface GeExpensesReportSuccessAction {
    type: typeof GET_EXPENSES_REPORT_SUCCESS
    payload: {
        report: IExpensesReport[]
    }
}

interface GeExpensesReportFailureAction {
    type: typeof GET_EXPENSES_REPORT_FAILURE
}

export type ActionTypes =
    | GeExpensesReportAction
    | GeExpensesReportSuccessAction
    | GeExpensesReportFailureAction
